import {RailsPartial} from '@github-ui/rails-partial'
import {pullRequestsChecksRoute} from './checks-route'

export function ChecksEntrypoint() {
  return <RailsPartial partialName="Main" route={pullRequestsChecksRoute} />
}
